import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { EpicAutoplayControl } from "epic/controls/epic-autoplay-control";

export class EpicAutoplayControlFactory implements ControlFactory {
    public filter(layer: Layers) {
        if (layer.getFlexiToggle("ui_autoplay")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers): AbstractControl[] {
        return [ new EpicAutoplayControl(layer.getFlexiToggle("ui_autoplay")) ];
    }
}
